<template>
  <div class="" v-if="structureData && structureData.length > 0">
    <a-tree
      :tree-data="structureData"
      @select="handleSelectDepartment"
      :defaultExpandAll="true"
      :show-icon="true"
      :show-line="true"
      :replace-fields="{
        children: 'children',
        title: 'structureName',
        key: 'id',
      }"
    >
      <template #icon>
        <ClusterOutlined />
      </template>
    </a-tree>
  </div>
</template>

<script>
import { defineComponent, inject, nextTick, reactive, ref, watch } from "vue";
import { ClusterOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: { ClusterOutlined },
  props: {
    expandedKeys: Array,
  },
  setup(props, context) {
    const structureData = inject("structureData", []);

    const selectedKeys = ref([]);

    let cacheKey = null;

    const getTree = (treeId) => {
      let fitem = null;

      const getTreeData = (list) => {
        const findItem = list.find((f) => f.id === treeId);
        if (findItem) {
          fitem = findItem;
        }
        if (!fitem) {
          list.forEach((item) => {
            if (item.children && item.children.length > 0) {
              getTreeData(item.children);
            }
          });
        }
      };

      getTreeData(structureData);

      return fitem;
    };

    const getUserList = (treeData) => {
      if (!treeData) return;
      const userList = [];

      const flatten = (list) => {
        list.forEach((item) => {

          if (item.userList && item.userList.length > 0) {
            userList.push(...item.userList);
          }

          if (item.children && item.children.length > 0) {
            flatten(item.children);
          }
        });
      };

      flatten([treeData]);

      context.emit(
        "handleSelectUserList",
        userList.sort((a, b) => a.jobNumber - b.jobNumber)
      );
    };

    const handleSelectDepartment = (key, e) => {
      const [id] = key;
      cacheKey = id;
      const treeData = getTree(id);

      getUserList(treeData);
    };

    const refreshData = () => {
      const treeData = getTree(cacheKey);

      getUserList(treeData);
    };

    const init = () => {
      setTimeout(() => {
        if (structureData && structureData.length > 0) {
          const [{ id }] = structureData;
          cacheKey = id;
          const treeData = getTree(cacheKey);
          getUserList(treeData);
        }
      }, 750);
    };

    init();

    return {
      refreshData,
      props,
      handleSelectDepartment,
      structureData,
      selectedKeys,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
